export enum USER_TYPE {
  CHILD = 'CHILD',
  LUMIIADMIN = 'LUMIIADMIN',
  SCHOOL = 'SCHOOL'
}

export enum USER_STATUS {
  CONFIRM_EMAIL,
  APPLICATION,
  SETUP_RATES,
  WAITING_FOR_APPROVE,
  ACTIVE,
  BLOCKED,
  REJECTED,
  FILLING_PROFILE = 7
}

export interface User {
  id?: number;
  first_name?: string;
  last_name?: string;
  userType?: string;
  email? :string;
  password?:	string;
  status?: string;
  phone?: string;
  code?: string;
  grade?: string;
  routes?: string[];
}

export interface Client{

}

export interface StartPhrase {
  feel: string;
  background: string;
  emoji: string
  id: number;
  lang: string;
}

export interface PhrasesDictionary {
  [key: string]: StartPhrase[];
}
